import { REGIONS } from "./regions.js";

const API_KEY = import.meta.env.VITE_SNOOOZ_API_KEY;
const USE_NGROK_HEADER = import.meta.env.VITE_USE_NGROK_HEADER === "true";

function buildHeaders(extra = {}) {
  return {
    ...extra,
    ...(USE_NGROK_HEADER ? { "ngrok-skip-browser-warning": "true" } : {})
  };
}

function getState(sessionBundle) {
  return sessionBundle?.state || sessionBundle || {};
}

export async function improveEmailText(payload, sessionBundle) {
  const state = getState(sessionBundle);
  const session = state?.session;
  const region = state?.region || "us";

  const improveEmailUrl =
    REGIONS[region]?.improveEmailUrl ||
    import.meta.env.VITE_SNOOOZ_IMPROVE_EMAIL_URL;

  if (!improveEmailUrl) {
    throw new Error("Missing improve email URL.");
  }

  if (!session?.companyId || !session?.userId) {
    throw new Error("Missing Snoooz session. Please reconnect your account.");
  }

  const res = await fetch(improveEmailUrl, {
    method: "POST",
    headers: buildHeaders({
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
      "x-user-token": session.companyId,
      "x-user-id": session.userId
    }),
    body: JSON.stringify(payload)
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(
      data?.details ||
      data?.error ||
      data?.message ||
      `Could not improve email. Status ${res.status}.`
    );

    err.status = res.status;
    err.data = data;
    throw err;
  }

  return {
    improvedText: data?.improvedText || data?.improved_draft || ""
  };
}